import { render, staticRenderFns } from "./CampaignProvider.vue?vue&type=template&id=5dc23613&"
import script from "./CampaignProvider.vue?vue&type=script&lang=js&"
export * from "./CampaignProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports